// extracted by mini-css-extract-plugin
export default {"subtitleLight":"hVVnwDI-mb7AizTUu3AqEg==","subtitleDark":"yv2oND-oKQyrpfVN1dKT-w=="};